import { CallOutlined } from "@mui/icons-material";
import { Fab } from "@mui/material";
import requests from "api/requests";
import { useSnackbar } from "notistack";
import useStatuses from "pages/admin/driverRequest/instanceModal/status/useStatuses";
import { useMemo } from "react";

interface IProps {
  id?: number;
  phone: string;
  atp_id?: number;
}

export default function CallButton(props: IProps) {
  const {
    id,
    phone,
    atp_id,
  } = props;
  const statusTypes = useStatuses();
  const { enqueueSnackbar } = useSnackbar();

  const statusID = useMemo(() => {
    const res = (statusTypes || []).filter((i) => i.name.toLowerCase() === "телефоную");
    if (res.length) {
      return res[0].id!
    }
    return null;
  }, [statusTypes])

  const onClick = () => {
    if (!statusID) return;
    requests.post('/admin/driver/request/status/', {
      status: statusID,
      request: id,
      atp_id: atp_id,
    }).then((r) => {
      enqueueSnackbar("Статус 'телефоную' додано", { variant: 'success' });
      const myEvent = new CustomEvent("DriverRequestStatus");
      document.dispatchEvent(myEvent);
      return r.body;
    })
  }

  return (
    <Fab size="small"
      href={`tel:${phone.replace(/[^+0-9]/g, "")}`}
      onClick={onClick}
      color="success"
      sx={{ mr: -1 }}
    >
      <CallOutlined />
    </Fab>
  )
}